import React, { useEffect, useState } from 'react';

// LOT 79 · ce qui ne se voit pas à l'ouverture (fenêtres, surveillants, tiroirs fermés) se monte juste après le premier affichage
export const Apres = ({ children, si = true, zone }) => {
  const [pret, setPret] = useState(!si);
  useEffect(() => {
    if (pret) return undefined;
    let id = 0; let t = 0;
    const go = () => setPret(true);
    id = requestAnimationFrame(() => { t = setTimeout(go, 0); });  // juste après la première image affichée
    return () => { cancelAnimationFrame(id); clearTimeout(t); };
  }, [pret]);
  if (zone) return <div data-differe79={zone} style={{ display: 'contents' }}>{pret ? children : <div className="l79-gris" aria-busy="true" data-testid={`${zone}-attente`} />}</div>;  // bloc gris le temps que la suite arrive
  return pret ? children : null;
};
